<template>
  <b-container fluid>
    <b-row>
        <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 81%">
          <b-button variant="primary" @click="pdfExport">
              {{  $t('globalTrans.export_pdf') }}
          </b-button>
        </b-col>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                     <b-row>
                        <b-col lg="5" sm="5">
                            <span class="text-dark">{{ $t('educational_management.fiscal_year') }} : {{ getFiscalYear(routineDetailData.fiscal_year_id) }}</span>
                        </b-col>
                        <b-col lg="7" sm="7">
                            <span class="text-dark">{{ $t('globalTrans.organization') }} : {{ getOrgName(routineDetailData.org_id) }}</span>
                        </b-col>
                        <b-col lg="5" sm="5">
                            <span class="text-dark">{{ $t('institute_manangement.institute_type') }} : {{ getInstituteType(routineDetailData.office_type_id) }}</span>
                        </b-col>
                         <b-col lg="7" sm="7">
                            <span class="text-dark">{{ $t('educational_management.institute_name') }} : {{ getOfficeName(routineDetailData.office_id) }}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                                <b-table-simple  bordered>
                        <thead>
                           <tr class="bg-primary">
                              <th scope="col">{{ $t('globalTrans.sl_no') }}</th>
                              <th scope="col">{{ $t('educational_management.date_and_time') }}</th>
                              <th scope="col">{{ $t('educational_management.course_name') }}</th>
                              <th scope="col">{{ $t('educational_management.teacher_name') }}</th>
                              <th scope="col">{{ $t('educational_management.remarks') }}</th>
                            </tr>
                        </thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in routineDetailData.details" :key="index">
                              <b-td> {{$n(index+1)}} </b-td>
                              <b-td> {{ item.routine_date  | dateFormat }} <br> {{ item.start_time }} - {{ item.end_time }} </b-td>
                              <b-td> {{ getCourseName(item.course_id) }} </b-td>
                              <b-td> {{ getTeacherName(item.instructor_id) }} </b-td>
                              <b-td> {{ (currentLocale === 'en') ? item.remark : item.remark_bn }} </b-td>
                           </b-tr>
                         </b-tbody>
                         </b-table-simple>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { childServiceBaseUrl } from '@/config/api_config'
// import { routineDetailApi } from '../../api/routes'
import { core } from '../../../../../config/pluginInit'
import ExportPdf from './export-routine-detail'

export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getRoutineData()
            this.routineDetailData = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            routineDetailData: {
            }
        }
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    methods: {
        getRoutineData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getCourseName (courseId) {
            const courseName = this.$store.state.ChildService.commonObj.courseList.find(item => item.value === courseId)
            if (this.$i18n.locale === 'bn') {
                return courseName.text_bn
            } else {
                return courseName.text
            }
        },
        getTeacherName (courseId) {
            const courseName = this.$store.state.ChildService.commonObj.instructorList.find(item => item.value === courseId)
            if (this.$i18n.locale === 'bn') {
                return courseName.text_bn
            } else {
                return courseName.text
            }
        },
        getFiscalYear (fiscalId) {
            const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalId)
            if (this.$i18n.locale === 'bn') {
                return fiscalYear.text_bn
            } else {
                return fiscalYear.text
            }
        },
        getOfficeName (officeId) {
            const officeName = this.$store.state.commonObj.officeList.find(item => item.value === officeId)
            if (this.$i18n.locale === 'bn') {
                return officeName.text_bn
            } else {
                return officeName.text
            }
        },
          getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
       },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getClassName (classId) {
            const className = this.$store.state.ChildService.commonObj.classList.find(item => item.value === classId)
            if (this.$i18n.locale === 'bn') {
                return className.text_bn
            } else {
                return className.text
            }
        },
        pdfExport () {
            const reportTitle = this.$t('educational_management.view_class_routine')
            ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.routineDetailData, this)
        }
    }
}

</script>
